import type { ComponentProps } from 'react';

const FailedCreation = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.4987 58.6654C47.2279 58.6654 59.1654 46.7279 59.1654 31.9987C59.1654 17.2695 47.2279 5.33203 32.4987 5.33203C17.7695 5.33203 5.83203 17.2695 5.83203 31.9987C5.83203 46.7279 17.7695 58.6654 32.4987 58.6654ZM42.6966 25.332L40.9258 27.1029L36.0299 31.9987L40.9258 36.8945L42.6966 38.6654L39.1654 42.1966L37.3945 40.4258L32.4987 35.5299L27.6029 40.4258L25.832 42.1966L22.3008 38.6654L24.0716 36.8945L28.9674 31.9987L24.0716 27.1029L22.3008 25.332L25.832 21.8008L27.6029 23.5716L32.4987 28.4674L37.3945 23.5716L39.1654 21.8008L42.6966 25.332Z"
        fill="#BE3F4B"
      />
    </svg>
  );
};

export default FailedCreation;
